import { render, staticRenderFns } from "./GoodsWantIndex.vue?vue&type=template&id=1393350c&scoped=true&"
import script from "./GoodsWantIndex.vue?vue&type=script&lang=js&"
export * from "./GoodsWantIndex.vue?vue&type=script&lang=js&"
import style0 from "./GoodsWantIndex.vue?vue&type=style&index=0&id=1393350c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1393350c",
  null
  
)

export default component.exports